import * as React from 'react';
import { JSSClassesProps } from 'react-jss';

import { Map } from '../Map';
import { MapLegend } from '../MapLegend';
import { ComponentJSSClasses } from './styles';


export interface StaticViewProps {
    latitude: number | null;
    longitude: number | null;
    beachType: string | null;
    beachSandType: string | null;
    distanceToAirport: number | null;
    distanceToBeach: number | null;
    howLongMinutesToCenterCity: number | null;
    isCenterCity: boolean;
}

interface StyledStaticViewProps extends JSSClassesProps<ComponentJSSClasses>, StaticViewProps { }


export function StaticView(props: StyledStaticViewProps) {
    const { classes } = props;

    if (!props.latitude || !props.longitude) {
        return null;
    }

    return (
        <>
            <div className={classes.container}>
                <Map
                    latitude={props.latitude}
                    longitude={props.longitude}
                    isAdaptive={true}
                />
            </div>
            <MapLegend
                beachType={props.beachType}
                beachSandType={props.beachSandType}
                distanceToAirport={props.distanceToAirport}
                distanceToBeach={props.distanceToBeach}
                howLongMinutesToCenterCity={props.howLongMinutesToCenterCity}
                isCenterCity={props.isCenterCity}
            />
        </>
    );
}
